
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a44"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a44"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $90a79fc3a7337a12$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["auyDg","index.255befb9.js","35Bw3","training-platform-screenshot.a3b0cf9b.png","6KQuR","management-platform-screenshot.a77c235c.png","3Q4mW","gamebook-services_logo_transp.209fd0b0.png","g4ROZ","ALARM-Partner.569bcb9b.png","1uhEc","Foto-Awarenes-Forum.410c8747.png","2aAz5","German_Map_DE.7baed562.png","82kA8","ResetPasswordView.68e3262d.js","2qBbj","RenewPasswordView.42c4d2a8.js","ia96m","DashboardView.66cb7a98.js","5j5Gk","DashboardView.8ae1c423.js","hH7d5","EmployeesView.99eae791.js","cwzsY","CompanyAnalyticsView.9d7fcd95.js","aD9MA","CompanySeatsView.bcf23d64.js","eiB8M","CompanySeatsView.9fcdc152.js","kUa44","CompanySubscriptionView.e83ab84e.js","jHoFG","CompanySubscriptionView.3c66b87f.js","f7AoK","CompanyInvoicesView.0790b81c.js","6GKMl","CompanyDetailsView.c77d63bd.js","gdTQa","CourseOverview.2583c994.js","eZ6Dk","CourseOverview.1ce08a84.js","8kb9x","EmployeeCourseOverview.bce73f5a.js","kPrXt","AccountSubscriptionView.0afd8dc4.js","ecW3v","AccountPaymentsView.41da213e.js","1pGvm","AccountDetailsView.33d40c2b.js","8koGT","index.e81df061.css"]'));


//# sourceMappingURL=index.runtime.b2eeb1d8.js.map
